import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { MessagesApplicationsPage } from './appPagesTableColumnsV2'
import PageForm from '../../Forms/PageForm'
import { isApplicationAdmin, isSuperUser } from '@/util'
import { useSessionStorage } from '@/hooks'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { toast } from 'sonner'
import { useCurrentApplication } from '../../useCurrentApplication'
import { useCallback } from 'react'

type MessagesApplicationsApplicationPages = RestSchemas['Messages.Applications.ApplicationPages']

export function RowActionsMenu({ row }: { row: MessagesApplicationsPage }) {
  const { applicationId } = useCurrentApplication()
  const [userRole] = useSessionStorage('roles', 1)
  const canEditOrDelete = isSuperUser(userRole) || isApplicationAdmin(userRole)

  const { getAppPagesApiGetApplicationPages, postAppPagesApiSaveApplicationPages } = useRestClient()

  const { data: existing } = getAppPagesApiGetApplicationPages.useQuery({ query: { applicationId } })
  const { mutateAsync: savePages } = postAppPagesApiSaveApplicationPages.useMutation()

  const handleDelete = useCallback(async () => {
    const currentItems = Array.isArray(existing?.items) ? existing.items : []
    const updatedItems = currentItems.filter((p) => p.id !== row.id)

    const updated: MessagesApplicationsApplicationPages = { items: updatedItems }

    try {
      await savePages({ query: { applicationId }, body: updated })
      await getAppPagesApiGetApplicationPages.invalidateQueries()
      toast.success('Page successfully deleted')
    } catch (error) {
      toast.error('Failed to delete page')
      console.error('Delete error:', error)
    }
  }, [applicationId, existing?.items, getAppPagesApiGetApplicationPages, row.id, savePages])

  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8 rounded-full">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <PageForm
            selectedPage={row}
            sheetTitle={`Edit page > ${row.description}`}
            sheetDescription="Edit the details of the page."
            sheetTrigger={
              <DropdownMenuItem disabled={!canEditOrDelete} onSelect={(e) => e.preventDefault()}>
                Edit page
              </DropdownMenuItem>
            }
          />
          <ConfirmDialog
            title="Delete page"
            description="Are you sure you want to delete this page?"
            onConfirm={handleDelete}
            trigger={
              <DropdownMenuItem disabled={!canEditOrDelete} onSelect={(e) => e.preventDefault()}>
                Delete page
              </DropdownMenuItem>
            }
          />
          {/* <ApplicationTeamForm
            delete
            selectedTeam={row}
            sheetTitle={`Delete team ► ${row.name}`}
            sheetDescription="Delete the application team."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Delete application team</DropdownMenuItem>
            }
          />
          <SupportTeamForm
            selectedSupportTeam={row}
            sheetTitle={`Maintain support team ► ${row.name}`}
            sheetDescription="Maintain the support team members."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain team members</DropdownMenuItem>
            }
          />
          <SupportTeamRolesForm
            appTeam={row}
            sheetTitle={`Maintain support team roles ► ${row.name}`}
            sheetDescription="Maintain the support team roles."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain team roles</DropdownMenuItem>}
          /> */}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
